import { render } from "./fw.vue?vue&type=template&id=ee108228&scoped=true"
import script from "./fw.vue?vue&type=script&lang=js"
export * from "./fw.vue?vue&type=script&lang=js"

import "./fw.vue?vue&type=style&index=0&id=ee108228&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee108228"]])

export default __exports__